<script lang="ts">
	import type { PromotionItem } from '$models/Block/PromotionBlock';
	import type { USPBlock } from '$models/Block/USPBlock';
	import PromotionItemComponent from '$components/Block/Promotion/PromotionItem.svelte';
	import USPBlockComponent from '$components/Block/USPBlock.svelte';

	interface Props {
		items: PromotionItem[];
		uspBlock: USPBlock;
	}

	const { items, uspBlock }: Props = $props();
	const useSplitLayout = $derived(items.length === 1);

	// TODO BE: When USPS block is true, it should be possible to have only 1 promotion item for the split layout.
	// Need to change that in the ACF field where now a minimum of 2 promotion items is required.

	// TODO BE: When USPS conditinal is true, the user should fill in the USPS block.
	// TODO BE NTH: Maybe nice to let the user choose a block pattern for the USPS block and pass it to the component.
</script>

<div
	class="promotion"
	class:promotion--with-usps={useSplitLayout}
	class:promotion--with-usps-above={!useSplitLayout}
>
	{#if useSplitLayout}
		<div class="promotion-split">
			<div class="promotion-split-usps">
				<USPBlockComponent block={uspBlock} />
			</div>
			<div class="promotion-split-promotions">
				<div class="promotion-inner promotion-inner--count-1">
					{#each items as item}
						<PromotionItemComponent {item} />
					{/each}
				</div>
			</div>
		</div>
	{:else}
		<div class="promotion-usps-above">
			<USPBlockComponent block={uspBlock} />
		</div>
		<div class="promotion-inner promotion-inner--count-{items.length}">
			<div class="promotion-grid promotion-grid--count-{items.length}">
				{#each items as item}
					<PromotionItemComponent {item} />
				{/each}
			</div>
		</div>
	{/if}
</div>

<style lang="postcss" global>
	.promotion {
		&--with-usps {
			.promotion-split {
				display: flex;
				flex-direction: column;
				gap: 16px;
			}

			.promotion-split-promotions .promotion-inner {
				display: flex;
				flex-direction: column;
				gap: 16px;
				height: 100%;
			}

			.promotion-split-promotions .promotion-item {
				flex: 1;
			}
		}

		&--with-usps-above {
			display: flex;
			flex-direction: column;
			gap: 16px;
		}

		&-grid {
			display: grid;
			grid-template-columns: 1fr;
			gap: 16px;

			&--count-2 {
				@media (--lg) {
					grid-template-columns: repeat(2, minmax(0, 1fr));
				}
			}

			&--count-3 {
				@media (--lg) {
					grid-template-columns: repeat(3, minmax(0, 1fr));
				}
			}

			&--count-4 {
				@media (--lg) {
					grid-template-columns: repeat(4, minmax(0, 1fr));
				}
			}
		}
	}

	@media (--lg) {
		.promotion--with-usps {
			.promotion-split {
				flex-direction: row;
				align-items: stretch;
				gap: 16px;
			}

			.promotion-split-usps,
			.promotion-split-promotions {
				flex: 1;
				min-width: 0;
			}

			.promotion-split-usps .usps-container,
			.promotion-split-usps .usps {
				height: 100%;
			}
		}
	}
</style>
